import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../theme';
import { Money } from '../../../Money';
import { MoneyType } from '../../../PriceMatrix/types';
import { default as BaseButton } from '../../../BaseComponents/Button';
import { SafeHtml } from '@shared/ui';

export interface Props {
	className?: string;
	classNameIcon?: string;
	icon: React.ReactNode;
	title: string;
	description?: string;
	hasSelected?: boolean;
	fromPrice: MoneyType;
	totalPrice: MoneyType;
	onAdd?: () => void;
	onEdit?: () => void;
	readOnly?: boolean;
}

const BaggageCard: React.FC<Props> = ({
	className,
	classNameIcon,
	icon,
	title,
	description,
	children,
	hasSelected,
	fromPrice,
	totalPrice,
	onAdd,
	onEdit,
	readOnly
}) => {
	const { BaggageCard: css } = useTheme('BaggageCard');
	const { t } = useTranslation('IncludedBaggage');

	const onClick = () => (hasSelected ? onEdit?.() : onAdd?.());

	return (
		<div className={cn(className, css.wrapper)}>
			<div
				className={cn(css.header, {
					[css.selected]: hasSelected
				})}
			>
				{!hasSelected && <div className={cn(css.icon, classNameIcon)}>{icon}</div>}

				<div className={css.info}>
					{title && <SafeHtml tag="div" className={css.title} html={title} />}
					{!hasSelected && description && (
						<SafeHtml tag="span" className={css.description} html={description} />
					)}
				</div>
			</div>

			{children}

			<div className={css.footer}>
				<span className={css.price}>
					{hasSelected ? t('total') : t('from')}
					<Money money={hasSelected ? totalPrice : fromPrice} roundType="ceil" />
				</span>

				<BaseButton
					variant={hasSelected ? 'optionEdit' : 'optionAction'}
					className={cn(css.button, {
						[css.button_edit]: hasSelected && !readOnly
					})}
					onClick={onClick}
				>
					{readOnly ? t('Checkout:More details') : t(hasSelected ? 'Edit' : 'Add')}
				</BaseButton>
			</div>
		</div>
	);
};

export default BaggageCard;
